@if (!editMode() && applicationStateService.userData.isTeacher) {
    <h3 [class.student]="!applicationStateService.userData.isTeacher" class="title">
        <img [src]="'sidebar/sidebar-icon-hsm.png' | asset">
        {{ 'hsm.sidebarHeadline' | translation : applicationStateService.bookConfig.publisherText }}
    </h3>
}

<div class="homework-add">
    <div>
        @if (!editMode()) {
            <button (click)="toggle()" [class.student]="!applicationStateService.userData.isTeacher"
                    [class.teacher]="applicationStateService.userData.isTeacher"
                    class="title btn btn-round btn-open btn-semibold m-auto">
                {{ 'hsm.openFormButton' | translation : applicationStateService.bookConfig.publisherText }} <i
                    class="fas fa-pencil-alt"></i>
            </button>
        }
        @if (editMode()) {
            <button (click)="toggle()" class="back-btn"><span class="triangle-left "></span>
                {{ 'hsm.backToOverview' | translation : applicationStateService.bookConfig.publisherText }}
            </button>
        }
        <!--        <div class="note" *ngIf="editMode()">-->
        <!--            <h4><i class="fas fa-lightbulb-on"></i> Hinweis</h4>-->
        <!--            <p>-->
        <!--                Bitte klicke auf "Aufgabe erstellen" bevor du die Sidebar schließt, andernfalls gehen deine Eingaben verloren.-->
        <!--            </p>-->
        <!--        </div>-->
        @if (editMode()) {
            <h2 class="text-left">{{ 'hsm.formHeadline' | translation : applicationStateService.bookConfig.publisherText }}</h2>
            <am-homework-form [prefix]="prefix" [schoolClasses]="applicationStateService.schoolClassList" [config]="hsmConfig" [exercises]="exercises" (exerciseChange)="onExerciseChange($event)" (homeworkCreated)="onHomeworkCreated($event)" (finishHomework)="onFinishHomework($event)"></am-homework-form>
        }
    </div>
</div>
